export default "__VITE_ASSET__Co4anl_y__"